import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.gdscript = bracketIndenting({
	line: "#",
})
